'use client'
import { DownArrow, UpArrow } from '@/shared/Icons'
import React, { useState } from 'react'
import MyImage from '../../myImage'
import stake from '@/assets/images/stake.svg'

function MatchProbability({ data }: any) {
  const oddData = data?.odds?.allOdds || data?.odds?.favOdds
  let tabs
  if (oddData) {
    tabs = [{ sTitle: '%View' }, { sTitle: 'Odds View' }]
  } else {
    tabs = [{ sTitle: '%View' }]
  }
  const [selectedTab, setSelectedTab] = useState(tabs[0])
  const teamAPercentage = data?.oWinPercent[0]?.sWinPercentage
  const teamBPercentage = data?.oWinPercent[1]?.sWinPercentage
  const tiePercentage = data?.oWinPercent[2]?.sWinPercentage

  if (teamAPercentage && teamBPercentage) {
    return (
      <section className='w-full'>
        <div className='flex justify-between items-center mb-4 mt-3'>
          <h3 className='font-bold text-lg mb-0 flex text-textOffWhite items-center justify-center md:justify-start'>
            <span>Probability</span>
          </h3>
          <div className='flex justify-center items-center gap-2 '>
            {tabs?.map((tab: any) => {
              return (
                <span
                  key={tab}
                  onClick={() => setSelectedTab(tab)}
                  className={` rounded-lg cursor-pointer text-xs font-bold px-3 py-2 border  ${
                    selectedTab?.sTitle === tab?.sTitle
                      ? 'text-white bg-primary-500 border-primary-500'
                      : ' dark:bg-transparent bg-white border-tabBorder text-textDselected '
                  }`}
                >
                  {tab?.sTitle}
                </span>
              )
            })}
          </div>
        </div>
        <div className={'p-4 dark:bg-transparent bg-white border border-tabBorder rounded-xl'}>
          {selectedTab?.sTitle === '%View' ? (
            <div className=''>
              <div className='flex h-2 w-full'>
                <div className='dark:!bg-[#4F5B29] bg-success-light h-full' style={{ width: `${teamAPercentage}%` }}></div>
                <div className='bg-[#D9D9D9] h-full' style={{ width: `${tiePercentage}%` }}></div>
                <div className='dark:!bg-[#802D41] bg-reject h-full' style={{ width: `${teamBPercentage}%` }}></div>
              </div>
              <div className='flex justify-between mt-4'>
                <span className='font-medium text-t-origin'>
                  {data?.oWinPercent[0]?.sTitle}
                  <span className='text-[#4F5B29] mx-1'>{teamAPercentage}%</span>
                </span>
                {tiePercentage && (
                  <span className='font-medium text-t-origin'>
                    DRAW
                    <span className='mx-1'>{tiePercentage}%</span>
                  </span>
                )}
                <span className='font-medium text-t-origin'>
                  {data?.oWinPercent[1]?.sTitle}
                  <span className='text-[#802D41] mx-1'>{teamBPercentage}%</span>
                </span>
              </div>
            </div>
          ) : (
            <>
              {oddData?.length > 0 && (
                <div className='flex w-full'>
                  {oddData?.map((o: any, i: number) => {
                    return (
                      <>
                        <div key={i} className='flex flex-col items-center w-full justify-between px-2 my-2'>
                          <div className='text-t-origin  font-medium self-center pe-3 whitespace-nowrap'>{o?.title}</div>
                          <div className='flex mt-2'>
                            {o?.back ? (
                              <div className='text-white text-xs  py-1 min-w-[35px] text-center font-bold self-stretch bg-confirm rounded-lg me-2'>
                                {o?.back}
                              </div>
                            ) : null}
                            {o?.lay ? (
                              <div className='text-white text-xs py-1 min-w-[35px] text-center font-bold self-stretch bg-reject  rounded-lg'>
                                {o?.lay}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        {i !== 2 && <div className='w-[1px] block h-full bg-separator-light' />}
                      </>
                    )
                  })}
                </div>
              )}
              <div className='flex justify-between px-2'>
                <div className='text-t-origin  font-medium self-center pe-3 whitespace-nowrap'>{oddData?.title}</div>
                <div className='flex'>
                  {oddData?.back ? (
                    <div className='flex items-center gap-2 font-bold self-stretch bg-greenBg px-2 py-1.5 rounded-md me-2 dark:text-[#E6E6E6] text-[#9EB23E]'>
                      <UpArrow />
                      {oddData?.back}
                    </div>
                  ) : null}
                  {oddData?.lay ? (
                    <div className='flex items-center gap-2 font-bold self-stretch bg-redBg px-2 py-1.5 rounded-md dark:text-[#E6E6E6] text-[#F17083]'>
                      <DownArrow />
                      {oddData?.lay}
                    </div>
                  ) : null}
                </div>
              </div>
              {data?.featuredSessions?.length > 0 && (
                <>
                  <div className='!w-full h-[1px] my-4 bg-separator-light' />
                  {data?.featuredSessions?.map((featuredSession: any, i: number) => {
                    return featuredSession?.title && featuredSession?.no > 0 && featuredSession?.yes > 0 ? (
                      <div className='flex justify-between px-2 mt-2' key={i}>
                        <div className='text-t-origin truncate font-medium self-center pe-3 whitespace-nowrap'>
                          {featuredSession?.title}
                        </div>
                        <div className='flex'>
                          {featuredSession?.no ? (
                            <div className='text-t-origin  font-bold self-stretch bg-priamry-500 px-6 py-1  rounded-lg me-2'>
                              {featuredSession?.no}
                            </div>
                          ) : null}
                          {featuredSession?.yes ? (
                            <div className='text-t-origin  font-bold self-stretch bg-redBg px-6 py-1 rounded-lg'>
                              {featuredSession?.yes}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ) : null
                  })}
                  <div className='!w-full h-[1px] my-4 bg-separator-light' />
                  <span className='text-center text-t-note'>{data?.featuredSessions[0]?.description}</span>
                  <div className='!w-full h-[1px] my-4 bg-separator-light' />
                  <div className='flex justify-between px-2'>
                    <span className='text-t-note'>
                      Open<span className='text-white mx-1'>{data?.featuredSessions[0]?.open}</span>
                    </span>
                    <span className='text-t-note'>
                      Min<span className='text-white mx-1'>{data?.featuredSessions[0]?.min}</span>
                    </span>
                    <span className='text-t-note'>
                      Max<span className='text-white mx-1'>{data?.featuredSessions[0]?.max}</span>
                    </span>
                  </div>
                </>
              )}
            </>
          )}

          <div className='mt-4 dark:bg-stakeGradient bg-[#F5F8F1] p-4 flex justify-center gap-5 items-center rounded-xl'>
            <p className='text-xs font-medium dark:text-[#D9D9D9] text-black text-textDselected'>Presented By</p>
            <MyImage src={stake} className=' dark:brightness-[1] brightness-0' height={27} width={55} />
          </div>
        </div>
      </section>
    )
  }
}

export default MatchProbability
